import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCBPvWZ4EAYmMjZROUKB1cNC4cpeT9mHu4",
    authDomain: "myjournal-f1a4b.firebaseapp.com",
    projectId: "myjournal-f1a4b",
    storageBucket: "myjournal-f1a4b.firebasestorage.app",
    messagingSenderId: "326791804053",
    appId: "1:326791804053:web:e4bb0b460cb25683d7179c",
    measurementId: "G-L9WRFJ2CR8"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);